module.exports = __webpack_public_path__ + "b09ddd9928c7ff6ad4dd749a1502a1c7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/flag-blue.png
// module id = 3030
// module chunks = 0